var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "widget-section",
    style: _vm.style
  }, [_c('div', {
    staticClass: "widget-container",
    attrs: {
      "id": _vm.divId
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };